export enum CalMode {
    CREATE = 0,
    PUBLISH = 1,
    SENT = 2,
    CANCEL = 3,
    VERIFY = 4,
    OTHER = 5
}
